export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0x976dd85654B3b2f9fb66280ACE30Cab7C81a2130",
  eulerSwapV1Implementation: "0x3620dAb0DB5595479a4D5408595D48FbE48CeA2A",
  eulerSwapV1Periphery: "0x34932C04c3d27c2BD7aCd0B5d203bfd65a17f481",
} as const
